export const MAX_MESSAGE_SIZE = 2000;
